import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { LegalLayout, LegalSection } from '../components/LegalLayout';

export default function Provenance() {
  return (
    <LegalLayout
      testid="provenance-page"
      eyebrow="Provenance & Authenticity"
      icon={BadgeCheck}
      title="Provenance & Authenticity"
      intro="For over 25 years, Lunar Legacies has specialized in authentic space memorabilia — flown artifacts, astronaut autographs, mission hardware, documents, and photographs."
      seo={{
        path: '/provenance',
        title: 'Provenance & Authenticity | Lunar Legacies',
        description: 'How Lunar Legacies researches and documents provenance and authenticity for space memorabilia — flown artifacts, astronaut autographs, hardware and documents.',
      }}
    >
      <LegalSection heading="Research & Documentation" testid="provenance-research">
        <p>
          Every item is researched and documented before it is offered. Where available, we present provenance, history, and
          the details that help establish an item's background, so collectors can understand what they are acquiring.
        </p>
      </LegalSection>

      <LegalSection heading="Careful Custody" testid="provenance-custody">
        <p>
          Items entrusted to us receive secure, careful handling and storage appropriate for delicate historical material.
        </p>
      </LegalSection>

      <LegalSection heading="How to Learn More" testid="provenance-learn">
        <p>
          We're glad to answer questions about any piece and to provide the information we have on its background and
          condition. For details on a specific lot, contact us before the sale.
        </p>
      </LegalSection>

      <LegalSection heading="Terms of Sale" testid="provenance-terms">
        <p>
          Purchases are governed by the terms shown on the active auction listing and our published auction terms. Please
          review those terms, and the terms of any third-party platform you bid through, before bidding.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
